import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import chevron from "../../assets/chevron.svg";
import "../../stylesheet/components/collapse/Collapse.scss";

type CollapseProps = {
  title: string;
  children?: React.ReactNode[];
};

const Collapse: React.FC<CollapseProps> = ({ title, children }) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const { ready } = useTranslation();

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="collapse-outer">
      <div
        className="collapse-button flex-middle flex-space-between"
        onClick={toggleCollapse}
      >
        <h6>{ready ? title : <Skeleton width={100} />}</h6>
        {collapsed ? (
          <img src={chevron} alt="chevron-up" className="filter-chevron" />
        ) : (
          <img
            src={chevron}
            alt="chevron-down"
            className="filter-chevron up-chevron"
          />
        )}
      </div>
      <div
        className={`${collapsed ? "collapsed" : "expanded"} ${
          children && children.length > 6 ? "scrollable-expanded" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Collapse;
